import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
    filter: {
        dateRange  : null,
        search     : null,
        location_id: null,
        campaign_id: null,
        region_id  : null,
        tag_id     : null,
    },

    isActiveChatMessenger: false,
};

export default new Vuex.Store({
    state,
    mutations,
    strict: process.env.NODE_ENV !== 'production',
});
